var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"flex items-center h-12 text-gray-dark bg-white border border-solid border-black-a20 rounded hover:border-primary-focus cursor-pointer"},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }